module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-3d-b05e6bef.svg";